import { useContext } from 'react';
import _ from 'underscore';
import type { UrlBuilderClass, UrlBuildersResult } from '@bingads-webui-clientcenter/url-builder-base';

import { UrlBuilderContext } from './url-builder-context';
import type { UrlBuilderResult, UseUrlBuilderOptions } from './types';

export const useUrlBuilder = (name?: string, {
  config
}: UseUrlBuilderOptions = {}): UrlBuilderResult => {
  const { urlBuilders } = useContext(UrlBuilderContext);
  return urlBuilders && _.isFunction(urlBuilders[name as keyof UrlBuildersResult]) ? new (urlBuilders[name as keyof UrlBuildersResult] as UrlBuilderClass)(config) : {};
};

export const useUrlHelper = () => {
  const { urlHelper } = useContext(UrlBuilderContext);
  return urlHelper;
};
